// Data of the "המתחם בתנועה" scene. Everything is in pixels of the aerial image (1858 x 827) and can be changed without touching the component.
// The streets were traced by hand on the picture: do not change them without checking the result on the image.

export const LIVING_SITE_IMAGE = '/renderings/living-site.webp';
export const IMAGE_W = 1858;
export const IMAGE_H = 827;

// Buildings: number, default units label, and the box on the image
export const TOWERS = [
  { n: 1,  u: '14/14', x: 1578, y: 108, w: 117, h: 110 },
  { n: 2,  u: '18/18', x: 1576, y: 222, w: 117, h: 110 },
  { n: 3,  u: '19/19', x: 1578, y: 334, w: 117, h: 110 },
  { n: 4,  u: '23/23', x: 1582, y: 442, w: 116, h: 115 },
  { n: 5,  u: '28/28', x: 1706, y: 637, w: 118, h: 112 },
  { n: 8,  u: '42/42', x: 1255, y: 640, w: 118, h: 110 },
  { n: 9,  u: '29/29', x: 1116, y: 657, w: 116, h: 118 },
  { n: 10, u: '26/26', x: 893,  y: 675, w: 116, h: 116 },
  { n: 11, u: '30/30', x: 740,  y: 628, w: 118, h: 118 },
  { n: 12, u: '32/32', x: 571,  y: 675, w: 116, h: 118 },
];

// Street centre-lines: cars drive both ways along them
export const STREETS = [
  [[416, 410], [430, 442], [439, 474], [453, 507], [469, 539], [492, 571], [527, 603], [543, 632], [551, 658], [559, 683], [567, 709], [571, 725]],
  [[543, 632], [600, 620], [651, 610], [703, 612], [754, 609], [806, 605], [857, 605], [909, 594], [961, 591], [1012, 589], [1064, 585], [1115, 583], [1167, 585], [1218, 589], [1270, 591], [1322, 596], [1373, 605], [1425, 605], [1476, 601], [1528, 587], [1579, 588], [1594, 590]],
];
export const CAR_COLORS = ['#e9eef2', '#27364a', '#c0392b', '#e8b923', '#6b7f95', '#f6f6f2'];

// Pedestrians stay inside open pavement / lawn: x0, x1, y0, y1, max drift
export const WALK_ZONES = [[1075, 1440, 590, 598, 60], [1340, 1480, 470, 520, 40], [545, 700, 262, 274, 40], [815, 885, 415, 455, 25]];

// Tree shimmer: rows [x0, x1, y, step, size] and areas [x0, w, y0, h, count, base size, extra]
export const TREE_ROWS = [[560, 1000, 614, 34, 28], [1060, 1500, 612, 34, 28], [1130, 1390, 272, 28, 24]];
export const TREE_AREAS = [[745, 250, 150, 410, 30, 40, 34], [1300, 200, 440, 110, 12, 34, 0]];

// Street lamps: along the avenue (y = 586) and the north-south street (x = 1018)
export const LAMPS = [];
for (let x = 30; x <= 1850; x += 70) LAMPS.push([x, 586]);
for (let y = 130; y <= 800; y += 90) LAMPS.push([1018, y]);

// Trams on the avenue on the right: left, top, travel distance, duration (s), delay (s)
export const TRAMS = [
  { left: 1696, top: -90, dist: 1010, dur: 26, delay: -4 },
  { left: 1720, top: 900, dist: -1010, dur: 30, delay: -17 },
];

// Water sparkles: count, x0, width, y0, height
export const SPARKLES = [[12, 1565, 70, 775, 45], [6, 1196, 32, 330, 44]];

// Cloud shadows: top, width, height, duration (s)
export const CLOUDS = [[40, 560, 240, 70], [330, 700, 300, 95], [560, 520, 220, 110], [150, 640, 260, 60]];
